import React, { useState } from "react";
import TextField from "@mui/material/TextField";

import {
  addDoc,
  collection,
  query,
  where,
  serverTimestamp,
} from "firebase/firestore";
import { db } from "../api/firebase";

import { useCollection } from "react-firebase-hooks/firestore";
// redux - use
import { useNotification } from "../redux/useNotification";

const RunruAddForVillagers = ({ setOpen, requestId }) => {
  // redux - Notification
  const { displayNotification } = useNotification();

  // ユーザ取得関連
  const usersRef = collection(db, "users");
  const [usersCollection] = useCollection(
    query(usersRef, where("isVillager", "==", true))
  );
  const users = usersCollection?.docs.map((user) => ({
    id: user.data().uid,
    ...user.data(),
  }));


  const [product, setProduct] = useState({
    amount: "",
    error: "",
    loading: false,
  });
  const { amount, error, loading } = product;

  // 値変更
  const handleChangeShop = (e) => {
    setProduct({
      ...product,
      [e.target.name]: e.target.value,
    });
  };

  // 登録処理
  const setRequestDataShop = async (e) => {
    e.preventDefault();
    setProduct({
      ...product,
      error: "",
      loading: true,
    });

    const addRunruForVillager = async (user) => {
      try {
        // 変更処理
        const docRef = await addDoc(collection(db, "runru"), {
          to: user.uid,
          toSexType: user?.sextype || "dontAnswer",
          toLastName: user?.lastName || "名字なし",
          toFirstName: user?.firstName || "名無し",
          toBloodType: user?.bloodtype || "dontAnswer",
          toBirthYear: user?.birthyear || "dontAnswer",
          toBirthMonth: user?.birthmonth || "dontAnswer",
          toBirthDay: user?.birthday || "dontAnswer",
          toPrefecture: user?.prefecture || "dontAnswer",
          from: "運営",
          amount: Number(amount),
          cause: "村民さん全体付与",
          createdAt: serverTimestamp(),
        });
        // window.location.reload();
        setOpen(false);
      } catch (err) {
        const errorData = {
          message: err.message,
          stack: err.stack,
        };
        addDoc(collection(db, "error"), {
          createdAt: serverTimestamp(),
          error: errorData,
          component: "RunruAddForVillagers",
        });

        setProduct({
          ...product,
          error: errorData,
          loading: false,
        });
      }
    };
    users?.forEach((user) => {
      addRunruForVillager(user);
    });
    displayNotification({
      message: "村民さん全体付与、成功しました。ページ更新後確認できます。",
      type: "success",
    });

  };

  //   console.log(product);
  return (
    <>
      <div>
        <div className="mb-3">ルンル村民さん全員付与</div>
        <form onSubmit={setRequestDataShop}>
          <div>村民さん全員に配布します</div>
          <div>村民さんの人数：{users?.length}人</div>

          {/* 価格（ルンル） */}
          <div className="my-4">
            <TextField
              id="outlined-required"
              name="amount"
              type="number"
              label="価格(ルンル)"
              defaultValue=""
              placeholder="100"
              size="small"
              onChange={handleChangeShop}
              required
              className="w-full my-4"
              disabled={loading}
            ></TextField>
          </div>

          {/* 登録ボタン */}
          <div className="my-4" />
          <button
            data-mdb-ripple="true"
            data-mdb-ripple-color="light"
            className="inline-block px-6 py-2.5 bg-blue-600 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out"
          >
            {loading ? "送信しています..." : "登録"}
          </button>
        </form>
        {error ? error : ""}
      </div>
    </>
  );
};

export default RunruAddForVillagers;
